module.exports = __webpack_public_path__ + "img/Weight Black.8ba1a002.png";